import { Component, inject } from '@angular/core';
import { WbsService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  WbsCreateDto,
  WbsDto,
  WbsExcelDownloadDto,
  WbsUpdateDto,
} from '../proxy/controlling/dtos/wbs';
import { WBS_CONFIG, WBS_FIELDS } from './wbs.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-wbs',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, WbsService, ConfirmationService],
  templateUrl: './wbs.html',
  styleUrl: './wbs.scss',
})
export class Wbs extends BaseCrudComponent<
  WbsDto,
  WbsCreateDto,
  WbsUpdateDto,
  WbsExcelDownloadDto
> {
  service = inject(WbsService);
  config = WBS_CONFIG;
  fields = WBS_FIELDS;

  protected prepareUpdateDto(data: any, selected: WbsDto): WbsUpdateDto {
    return {
      name: data.name,
      sapCode: data.sapCode,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Wbs';
  }
}
